import React from 'react';
import {Heading, Box} from 'native-base';

const HeaderBox = () => {
  return (
    <>
      <Box
        paddingBottom={0}
        borderTopColor="blue.200"
        borderTopWidth={1}
        marginBottom={3}
        marginX={5}>
        <></>
      </Box>
      <Heading
        color="#06355E"
        fontSize="14"
        fontWeight="medium"
        marginBottom={3}
        marginX={5}>
        Clientes{' '}
      </Heading>
    </>
  );
};

export default HeaderBox;
